export enum CanPayCashOrderResult {
  NotSupported = 0,
  Supported = 1,
  PaymentInProgress = 2,
}
